<template>
  <img :src="src" alt="" v-if="src" :class="{ ...props }" />
  <div v-else-if="text" :class="{ ...props }" class="text-avatar medium">
    {{ initials }}
  </div>
  <svg :class="{ ...props }" height="32" width="32" v-else viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 13.1479C7 11.9617 8.00988 11 9.25559 11C10.5013 11 11.5112 11.9617 11.5112 13.1479C11.5112 14.3341 10.5013 15.2958 9.25559 15.2958C8.00988 15.2958 7 14.3341 7 13.1479Z"
      fill="#3A9CFF"
    />
    <path
      d="M25.4958 21.7395H7.45112V19.162L9.6793 17.0402C9.9436 16.7885 10.372 16.7885 10.6363 17.0402L12.8645 19.162L19.6039 12.7444C19.8682 12.4927 20.2966 12.4927 20.5609 12.7444L25.4958 17.4437V21.7395Z"
      fill="#3A9CFF"
    />
  </svg>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { extractInitials } from '@/utils/strings';

  export interface Props {
    src?: string | null;
    large?: boolean;
    larger?: boolean;
    small?: boolean;
    text?: string;
    grayscale?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {});

  const initials = computed(() => {
    if (props.text) {
      return extractInitials(props.text).split('').splice(0, 2).join('');
    }
    return '';
  });
</script>

<style lang="scss" scoped>
  @import '@styles/variables.scss';

  svg {
    background-color: #e1f7ff;
  }

  img {
    background-color: $neutral-gray-10;
  }

  .text-avatar,
  img,
  svg {
    height: 2rem;
    width: 2rem;
    aspect-ratio: 1;
    border-radius: 50%;
    object-fit: cover;
    image-rendering: optimizeSpeed;

    &.large {
      height: 3rem;
      width: 3rem;
    }

    &.larger {
      height: 4.375rem;
      width: 4.375rem;
    }
    &.small {
      height: 1.5rem;
      width: 1.5rem;
    }
    &.grayscale {
      filter: grayscale(1);
    }
  }

  .text-avatar {
    background-color: $primary-lighter;
    display: grid;
    place-items: center;
    border: 1px solid $white;
    font-size: 1rem;
    font-weight: 500;
  }
</style>
